import { render, staticRenderFns } from "./provider-payload.vue?vue&type=template&id=80ebe8c0&scoped=true&"
import script from "./provider-payload.ts?vue&type=script&lang=ts&"
export * from "./provider-payload.ts?vue&type=script&lang=ts&"
import style0 from "./provider-payload.vue?vue&type=style&index=0&id=80ebe8c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ebe8c0",
  null
  
)

export default component.exports